import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

const EXTRA_ROWS = ['aup', 'do'];

export default function Salary({ apiKey }: { apiKey: string }) {
  const [configs, setConfigs] = useState<string[]>([]);
  const [salaries, setSalaries] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');
  // Длительность отчёта из общих настроек. Раньше здесь стояло жёсткое «× 12», из-за чего
  // страница противоречила тому, что реально вычитается из расходов в отчётах.
  const [months, setMonths] = useState<number | null>(null);

  const headers = { 'X-API-Key': apiKey };

  useEffect(() => {
    Promise.all([
      fetch(`${API_URL}/configs`, { headers }).then((r) => r.json()),
      fetch(`${API_URL}/salaries`, { headers }).then((r) => r.json()),
      fetch(`${API_URL}/overall/settings`, { headers }).then((r) => r.json()).catch(() => ({})),
    ])
      .then(([cfgData, salData, setData]) => {
        setMonths(setData?.settings?.months ?? null);
        setConfigs(cfgData.configs || []);
        const stored = salData.salaries || {};
        const asStrings: Record<string, string> = {};
        for (const k of Object.keys(stored)) {
          asStrings[k] = stored[k] === null || stored[k] === undefined ? '' : String(stored[k]);
        }
        setSalaries(asStrings);
      })
      .finally(() => setLoading(false));
  }, [apiKey]);

  const updateSalary = (key: string, value: string) => {
    setSalaries((prev) => ({ ...prev, [key]: value }));
  };

  const save = async () => {
    setSaving(true);
    setStatus('');
    const payload: Record<string, number> = {};
    for (const key of Object.keys(salaries)) {
      const trimmed = salaries[key].trim();
      if (trimmed === '') continue;
      const num = Number(trimmed);
      if (!Number.isNaN(num)) payload[key] = num;
    }
    try {
      const res = await fetch(`${API_URL}/salaries`, {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('save failed');
      setStatus('Сохранено');
    } catch {
      setStatus('Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="report"><p>Загрузка...</p></div>;

  const rows = [...configs, ...EXTRA_ROWS];
  const total = rows.reduce((sum, key) => {
    const n = Number((salaries[key] ?? '').trim());
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
  const formatNumber = (n: number) => n.toLocaleString('ru-RU');

  return (
    <div className="report">
      <h2>АУП Зп</h2>
      <p className="salary-hint">Зарплата АУП на каждый конфиг. Используется для распределения по долям.</p>
      <div className="salary-list">
        {rows.map((key) => (
          <div key={key} className="salary-row">
            <span className="salary-config">{key}</span>
            <input
              type="number"
              step="any"
              placeholder="0"
              value={salaries[key] ?? ''}
              onChange={(e) => updateSalary(key, e.target.value)}
            />
          </div>
        ))}
      </div>
      <div className="salary-totals">
        <div><span className="salary-totals-label">Итого:</span> {formatNumber(total)}</div>
        <div>
          <span className="salary-totals-label">
            {months === null ? 'Итого × период:' : `Итого × ${months} мес.:`}
          </span>{' '}
          {months === null ? '—' : formatNumber(total * months)}
          <span className="salary-months-hint">
            {months === null
              ? ' длительность отчёта не задана — задаётся на странице «Сводный» → Настройки'
              : ' это и есть пул, который распределяется по строке «ЗП АУП»'}
          </span>
        </div>
      </div>
      <div className="salary-actions">
        <button onClick={save} disabled={saving}>{saving ? 'Сохранение...' : 'Сохранить'}</button>
        {status && <span className="salary-status">{status}</span>}
      </div>
    </div>
  );
}
